import React from 'react';
import { formatCurrency } from './utils';

interface DetailAppraisalSectionProps {
  appraisalData: any;
}

export default function DetailAppraisalSection({ appraisalData }: DetailAppraisalSectionProps) {
  return (
    <div className="mt-6 pt-6 border-t">
      <h4 className="font-semibold mb-4">Taksasi Agunan</h4>
      <div className="space-y-6">
        {/* Price Sources */}
        {appraisalData.price_sources &&
          Array.isArray(appraisalData.price_sources) &&
          appraisalData.price_sources.length > 0 && (
            <div>
              <label className="text-sm font-medium text-gray-700 mb-2 block">
                Harga Menurut Sumber
              </label>
              <div className="space-y-3">
                {appraisalData.price_sources.map((source: any, index: number) => (
                  <div key={index} className="border rounded-lg p-4 bg-gray-50">
                    <div className="grid md:grid-cols-2 gap-4">
                      <div>
                        <label className="text-xs text-gray-600">Sumber / Deskripsi</label>
                        <p className="font-medium mt-1">
                          {source.source_name || source.description || '-'}
                        </p>
                      </div>
                      <div>
                        <label className="text-xs text-gray-600">Harga</label>
                        <p className="font-medium mt-1">
                          {formatCurrency(source.value || source.price || 0)}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

        {/* Positive Factors */}
        {appraisalData.positive_factors &&
          Array.isArray(appraisalData.positive_factors) &&
          appraisalData.positive_factors.length > 0 && (
            <div>
              <label className="text-sm font-medium text-gray-700 mb-2 block">Faktor Positif</label>
              <div className="space-y-3">
                {appraisalData.positive_factors.map((factor: any, index: number) => (
                  <div key={index} className="border rounded-lg p-4 bg-green-50">
                    <div className="grid md:grid-cols-3 gap-4">
                      <div>
                        <label className="text-xs text-gray-600">Deskripsi</label>
                        <p className="font-medium mt-1">{factor.description || '-'}</p>
                      </div>
                      <div>
                        <label className="text-xs text-gray-600">Nilai</label>
                        <p className="font-medium mt-1">{formatCurrency(factor.value || 0)}</p>
                      </div>
                      <div>
                        <label className="text-xs text-gray-600">Persentase</label>
                        <p className="font-medium mt-1">{factor.percentage || 0}%</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

        {/* Negative Factors */}
        {appraisalData.negative_factors &&
          Array.isArray(appraisalData.negative_factors) &&
          appraisalData.negative_factors.length > 0 && (
            <div>
              <label className="text-sm font-medium text-gray-700 mb-2 block">Faktor Negatif</label>
              <div className="space-y-3">
                {appraisalData.negative_factors.map((factor: any, index: number) => (
                  <div key={index} className="border rounded-lg p-4 bg-red-50">
                    <div className="grid md:grid-cols-3 gap-4">
                      <div>
                        <label className="text-xs text-gray-600">Deskripsi</label>
                        <p className="font-medium mt-1">{factor.description || '-'}</p>
                      </div>
                      <div>
                        <label className="text-xs text-gray-600">Nilai</label>
                        <p className="font-medium mt-1">{formatCurrency(factor.value || 0)}</p>
                      </div>
                      <div>
                        <label className="text-xs text-gray-600">Persentase</label>
                        <p className="font-medium mt-1">{factor.percentage || 0}%</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

        {/* POJK and Liquidation */}
        <div className="grid md:grid-cols-3 gap-4">
          {appraisalData.pojk_type && (
            <div>
              <label className="text-sm text-gray-600">Jenis POJK</label>
              <p className="font-medium mt-1">{appraisalData.pojk_type}</p>
            </div>
          )}
          {appraisalData.pojk_percentage !== undefined &&
            appraisalData.pojk_percentage !== null && (
              <div>
                <label className="text-sm text-gray-600">Persentase POJK</label>
                <p className="font-medium mt-1">{appraisalData.pojk_percentage}%</p>
              </div>
            )}
          {appraisalData.liquidation_percentage !== undefined &&
            appraisalData.liquidation_percentage !== null && (
              <div>
                <label className="text-sm text-gray-600">Persentase Likuidasi</label>
                <p className="font-medium mt-1">{appraisalData.liquidation_percentage}%</p>
              </div>
            )}
        </div>

        {/* Calculated Values */}
        {appraisalData.appraisal_value && (
          <div className="border-t pt-4">
            <div className="grid md:grid-cols-3 gap-4">
              <div>
                <label className="text-sm font-medium text-gray-700">Nilai Taksasi</label>
                <p className="font-bold text-lg mt-1 text-blue-600">
                  {formatCurrency(appraisalData.appraisal_value)}
                </p>
              </div>
              {appraisalData.pojk_value && (
                <div>
                  <label className="text-sm font-medium text-gray-700">Nilai POJK</label>
                  <p className="font-bold text-lg mt-1 text-green-600">
                    {formatCurrency(appraisalData.pojk_value)}
                  </p>
                </div>
              )}
              {appraisalData.liquidation_value && (
                <div>
                  <label className="text-sm font-medium text-gray-700">Nilai Likuidasi</label>
                  <p className="font-bold text-lg mt-1 text-orange-600">
                    {formatCurrency(appraisalData.liquidation_value)}
                  </p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
